import { Component, Input } from '@angular/core';

@Component({
  selector: 'app-form-conciliazione-stragiudiziale-view',
  templateUrl: './form-conciliazione-stragiudiziale-view.component.html',
  styleUrls: ['./form-conciliazione-stragiudiziale-view.component.css']
})
export class FormConciliazioneStragiudizialeViewComponent {

  @Input() ctxBodyFascicolo;
  constructor() {}
}
